export default {
  "Correo Electrónico": "Correo Electrónico",
  Contraseña: "Contraseña",
  "Usuario o contraseña incorrectos.": "Usuario o contraseña incorrectos.",
  "Inténtalo nuevamente.": "Inténtalo nuevamente.",
  "Iniciar sesión": "Iniciar sesión",
  "Tiempo y Estado": "Tiempo y Estado",
  "Tiempos de Trabajo": "Tiempos de Trabajo",
  "Entrega de Piedra": "Entrega de Piedra",
  "Entrega de Fornituras": "Entrega de Fornituras",
  Engaste: "Engaste",
  "Control de Calidad": "Control de Calidad",
  "Consultar Tiempos": "Consultar Tiempos",
  "Ajustar Tiempo trabajado": "Ajustar Tiempo trabajado",
  "Ajustar tiempo Standard": "Ajustar tiempo Standard",
  "Carga de Fábrica": "Carga de Fábrica",
  "Estado Operarios": "Estado Operarios",
  "Control del oro": "Control del oro",
  "Estado General": "Estado General",
  Fundición: "Fundición",
  Agrupaciones: "Agrupaciones",
  Asignación: "Asignación",
  Reparaciones: "Reparaciones",
  "Validar Calidad": "Validar Calidad",
  Piedras: "Piedras",
  Escáner: "Escáner",
  "Pesaje Inicial": "Pesaje Inicial",
  "Pesaje Repaso": "Pesaje Repaso",
  "Pesaje Fornituras": "P. Fornituras",
  "Pesaje Final": "Pesaje Final",
  Mecanizado: "Mecanizado",
  Documentación: "Documentos",
  Administración: "Administración",
  "Buscar PO / MO / REF": "Buscar PO / MO / REF",
  MOs: "MOs",
  Inicio: "Inicio",
  Fin: "Fin",
  Reparaciones: "Reparaciones",
  "Tabla de PO": "Tabla de PO",
  "MO Activas": "MO Activas",
  "Total MO": "Total MO",
  MO: "MO",
  Referencia: "Referencia",
  Team: "Equipo",
  Equipo: "Team",
  Usuario: "Usuario",
  Tipo: "Tipo",
  "Fec. Fin": "Fecha Fin",
  Incidencia: "Incidencia",
  "Tiempo / Peso / Piedras": "Tiempo / Peso / Piedras",
  "Código de MO": "Código de MO",
  "Seleccione Usuario": "Seleccione Usuario",
  "Asignar todos": "Asignar todos",
  "Mostrar solo mi equipo": "Mostrar solo mi equipo",
  "Mostrar todos": "Mostrar todos",
  "No hay datos disponibles.": "No hay datos disponibles.",
  Cantidad: "Cantidad",
  Entrega: "Entrega",
  Observaciones: "Observaciones",
  Entregado: "Entregado",
  Recibido: "Recibido",
  Acciones: "Acciones",
  Taller: "Taller",
  "Asignar a": "Asignar a",
  "Control de Piedras": "Control de Piedras",
  "Entrada/todos": "Entrada/todos",
  "Salida/todos": "Salida/todos",
  "No hay MOs pendientes...": "No hay MOs pendientes...",
  "Bagging a la espera": "Bagging a la espera",
  "Bagging Completo": "Bagging Completo",
  Entrada: "Entrada",
  Salida: "Salida",
  PO: "PO",
  Código: "Código",
  Bagging: "Bagging",
  "Buscar por MO": "Buscar por MO",
  Pendientes: "Pendientes",
  Historico: "Histórico",
  "No hay resultados para la búsqueda.": "No hay resultados para la búsqueda.",
  "No hay resultados para la búsqueda o la fecha seleccionada.":
    "No hay resultados para la búsqueda o la fecha seleccionada.",
  "Seleccionar Fecha": "Seleccionar Fecha",
  "Quitar filtro": "Quitar filtro",
  "Quitar filtros": "Quitar filtros",
  "Fecha desde": "Fecha desde",
  "Fecha hasta": "Fecha hasta",
  "Total orden": "Total orden",
  "Exportar excel": "Exportar excel",
  "pieza(s)": "pieza(s)",
  "Buscar por cualquier campo...": "Buscar por cualquier campo...",
  "Guardar Datos": "Guardar Datos",
  "Nº Reparación": "Nº Reparación",
  "Fecha Entrega": "Fecha Entrega",
  Trabajo: "Trabajo",
  "Peso Entregado": "Peso Entregado",
  "Peso Devolución": "Peso Devolución",
  Diferencia: "Diferencia",
  Merma: "Merma",
  "Fecha Devolución": "Fecha Devolución",
  "Precio (€)": "Precio (€)",
  "Importe total": "Importe total",
  "Merma total": "Merma total",
  "Buscar MO o Referencia": "Buscar MO o Referencia",
  "Validar Pesos": "Validar Pesos",
  "Cantidad Proceso": "Cantidad Proceso",
  "Peso Teórico": "Peso Teórico",
  "Desviación (%)": "Desviación (%)",
  "No hay MOs que autorizar": "No hay MOs que autorizar",
  Validar: "Validar",
  Peso: "Peso",
  "Tabla de MO": "Tabla de MO",
  "Todos los pesos añadidos": "Todos los pesos añadidos",
  "Registrar Peso": "Registrar Peso",
  "Peso gramos metal": "Peso gramos metal",
  Registrar: "Registrar",
  "Gramos recorte": "Gramos recorte",
  "Gramos piezas": "Gramos piezas",
  "Registrar el Peso": "Registrar el Peso",
  "El valor de peso es inválido o cero.":
    "El valor de peso es inválido o cero.",
  "El valor de cantidad es inválido o cero.":
    "El valor de cantidad es inválido o cero.",
  "El peso excede el límite permitido. Por favor, introduce la contraseña (JM o JR) para continuar:":
    "El peso excede el límite permitido. Por favor, introduce la contraseña (JM o JR) para continuar:",
  "Peso añadido correctamente con autorización.":
    "Peso añadido correctamente con autorización.",
  "Contraseña incorrecta. No se puede continuar.":
    "Contraseña incorrecta. No se puede continuar.",
  "Peso añadido correctamente.": "Peso añadido correctamente.",
  "Registrar Peso Intermedio": "Registrar Peso Intermedio",
  Recorte: "Recorte",
  "Tabla de MO": "Tabla de MO",
  "Código de MO": "Código de MO",
  PO: "PO",
  MO: "MO",
  Cantidad: "Cantidad",
  Referencia: "Referencia",
  Entrega: "Entrega",
  Stamping: "Stamping",
  "Cant. Term.": "Cant. Term.",
  Peso: "Peso",
  "Añadir Peso": "Añadir Peso",
  Añadir: "Añadir",
  "Filas por página:": "Filas por página:",
  "Todos los pesos añadidos": "Todos los pesos añadidos",
  "aprox:": "aprox:",
  "Res:": "Res:",
  "El peso no es correcto.": "El peso no es correcto.",
  "La cantidad ingresada excede la pendiente.":
    "La cantidad ingresada excede la pendiente.",
  "¿El peso: {weight} es correcto?": "¿El peso: {weight} es correcto?",
  "El peso no cumple con los límites esperados.":
    "El peso no cumple con los límites esperados.",
  "Buscar por cliente o nombre": "Buscar por cliente o nombre",
  "Tabla de Documentación": "Tabla de Documentación",
  "#": "#",
  Cliente: "Cliente",
  Nombre: "Nombre",
  Acciones: "Acciones",
  "No se encontraron resultados para la búsqueda.":
    "No se encontraron resultados para la búsqueda.",
  "Todos los documentos han sido cargados.":
    "Todos los documentos han sido cargados.",
  "Información de Orden": "Información de Orden",
  "Referencia:": "Referencia:",
  "{referencia} - {descripcion}": "{referencia} - {descripcion}",
  "PO:": "PO:",
  "MO:": "MO:",
  "Unidades:": "Unidades:",
  "Fabricada:": "Fabricada:",
  "Pendiente:": "Pendiente:",
  "Fecha de entrega:": "Fecha de entrega:",
  "Tipo orden:": "Tipo orden:",
  "Clasificación Cliente:": "Clasificación Cliente:",
  "Observaciones:": "Observaciones:",
  "Stamping:": "Stamping:",
  "No disponible": "No disponible",
  LGD: "LGD",
  Icono: "Icono",
  Operario: "Operario",
  "Min. Real": "Min. Real",
  Unidades: "Unidades",
  Standard: "Standard",
  "Seleccionar Equipo": "Seleccionar Equipo",
  "Todos los equipos": "Todos los equipos",
  Cerrar: "Cerrar",
  Tiempos: "Tiempos",
  Incidencias: "Incidencias",
  Problema: "Problema",
  Solución: "Solución",
  "Cantidad Incidencia": "Cantidad Incidencia",
  "Cantidad Total": "Cantidad Total",
  "El contador está en funcionamiento. Por favor, detén el contador antes de salir.":
    "El contador está en funcionamiento. Por favor, detén el contador antes de salir.",
  Atención: "Atención",
  "Detener el contador antes de salir.": "Detener el contador antes de salir.",
  "No hay incidencias registradas.": "No hay incidencias registradas.",
  Quilates: "Quilates",
  AVG: "AVG",
  "Nº Piedras": "Nº Piedras",
  "Check piedras": "Check piedras",
  "Check taller": "Check taller",
  "Check Fornituras": "Check Fornituras",
  Duracion: "Duración",
  "Cantidad de piezas": "Cantidad de piezas",
  Comentario: "Comentario",
  "Peso Restante": "Peso Restante",
  "Calidad añadida.": "Calidad añadida.",
  "Contraseña incorrecta.": "Contraseña incorrecta.",
  "Contraseña correcta.": "Contraseña correcta.",
  "Multiples MOs": "Múltiples MOs",
  "Ver Documentos": "Ver Documentos",
  Documentos: "Documentos",
  "No se encontraron documentos que coincidan con los criterios.":
    "No se encontraron documentos que coincidan con los criterios.",
  "Resultados de la consulta": "Resultados de la consulta",
  "Tabla de Metales": "Tabla de Metales",
  "Total:": "Total:",
  "Tabla de Agrupaciones": "Tabla de Agrupaciones",
  "Resultados de la consulta": "Resultados de la consulta",
  Aceptar: "Aceptar",
  Cancelar: "Cancelar",
  "Tabla de Metales": "Tabla de Metales",
  "Total:": "Total:",
  "Tabla de Agrupaciones": "Tabla de Agrupaciones",
  "Nº líneas:": "Nº líneas:",
  Finalizar: "Finalizar",
  "#": "#",

  Aleación: "Aleación",
  Referencia: "Referencia",
  "Fecha Agrupación": "Fecha Agrupación",
  Cantidad: "Cantidad",
  Gramos: "Gramos",
  Acciones: "Acciones",
  "Reset a Fundición": "Reset a Fundición",
  "Tabla de MO": "Tabla de MO",
  Entrega: "Entrega",
  "Tipo orden": "Tipo orden",
  "Crear Agrupación": "Crear Agrupación",
  Buscar: "Buscar",
  "Tabla de Agrupaciones finalizadas": "Tabla de Agrupaciones finalizadas",
  Agrupación: "Agrupación",
  "#": "#",
  Aleación: "Aleación",
  PO: "PO",
  MO: "MO",
  Tipo: "Tipo",
  Peso: "Peso",
  Lote: "Lote",
  Fecha: "Fecha",
  "Informacion Relevante": "Información Relevante",
  Reparaciones: "Reparaciones",
  "Estado Fundición": "Estado Fundición",
  "Carga de Fabrica": "Carga de Fábrica",
  Fornituras: "Fornituras",
  Proveedor: "Proveedor",
  "Stock Córdoba": "Stock Córdoba",
  "Stock Euroshine": "Stock Euroshine",
  "STO 1990": "STO 1990",
  "STO 1987": "STO 1987",
  "Filtrar columna": "Filtrar columna",
  Contiene: "Contiene",
  "Texto del filtro": "Texto del filtro",
  Limpiar: "Limpiar",
  Aplicar: "Aplicar",
  "Buscar en lista de valores": "Buscar en lista de valores",
  "Seleccionar todo (visible)": "Seleccionar todo (visible)",
  "Quitar filtro": "Quitar filtro",
  Detalle: "Detalle",
  Información: "Información",
  "* Días hasta fecha de entrega": "* Días hasta fecha de entrega",
  "Unidades Pendientes": "Unidades Pendientes",
  Total: "Total",
  "Cant. Ped.": "Cant. Ped.",
  "En retraso": "En retraso",
  MO: "MO",
  Referencia: "Referencia",
  "Fecha Orden": "Fecha Orden",
  "Fecha de Entrega": "Fecha de Entrega",
  "Cantidad Pendiente": "Cantidad Pendiente",
  Categoría: "Categoría",
  "No se encontraron resultados": "No se encontraron resultados",
  "No se encontraron datos.": "No se encontraron datos.",
  "Buscar MO": "Buscar MO",
  "Introduzca MO": "Introduzca MO",
  "Restante: {days} días": "Restante: {days} días",
  "Estado: Retrasado": "Estado: Retrasado",
  "No se encontraron resultados.": "No se encontraron resultados.",
  día: "día",
  días: "días",
  "En retraso": "En retraso",
  Meses: "Meses",
  Total: "Total",
  "Total General": "Total General",
  "Resumen de Piezas por Operario": "Resumen de Piezas por Operario",
  "Total Piezas": "Total Piezas",
  "Assignment price lines report": "Informe WO Externas",
  "Pesar fornituras": "Pesar fornituras",
  "No hay líneas de fornitura pendientes de pesar para esta MO":
    "No hay líneas de fornitura pendientes de pesar para esta MO",
  "Introduzca un peso válido": "Introduzca un peso válido",
  "Peso registrado correctamente": "Peso registrado correctamente",
  "Error al cargar fornituras": "Error al cargar fornituras",
  "Error al añadir peso de fornitura": "Error al añadir peso de fornitura",
};
